import React, { InputHTMLAttributes, forwardRef, ReactNode } from 'react';
import styles from './style.module.css';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  label: string;
  icon: ReactNode;
  onChange?: (checked: boolean) => void;
  containerClassName?: string;
  labelClassName?: string;
  iconClassName?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
    label,
    icon,
    checked,
    onChange,
    disabled = false,
    className = '',
    containerClassName = '',
    labelClassName = '',
    iconClassName = '',
    id,
    ...props
  }, ref) => {
  const checkboxId = id || `checkbox-${Math.random().toString(36).slice(2, 9)}`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (onChange) {
        onChange(!checked);
      }
    }
  };

  return (
    <label
      className={`
        ${styles.checkbox} 
        ${disabled ? styles.disabled : ''} 
        ${containerClassName}
      `.trim()}
      htmlFor={checkboxId}
      onKeyDown={handleKeyDown}
      tabIndex={disabled ? -1 : 0}
    >
      {/* Иконка слева */}
      <div className={`${styles.iconWrapper} ${iconClassName}`}>
        {icon}
      </div>

      {/* Текст по центру */}
      <span
        className={`
          ${styles.label} 
          ${disabled ? styles.disabled : ''} 
          ${labelClassName}
        `.trim()}
      >
        {label}
      </span>

      {/* Чекбокс справа */}
      <div className={styles.checkboxIndicator}>
        <input
          {...props}
          ref={ref}
          type="radio"
          id={checkboxId}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={`${styles.checkboxInput} ${className}`}
        />
        <span className={styles.checkboxCircle} />
      </div>
    </label>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;